@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.footer {
    display: flex;
    flex-direction: column;
    background-color: var(--white);
    font-family: typography.$font-mont;
  
    @include breakpoints.desktop {
      flex-direction: row;
      padding-top: 44px;
      padding-left: 0;
      padding-right: 0;
    }
  }
  
  .footerSection {
    flex: 1;
  
    @include breakpoints.desktop {
      display: flex;
      flex-direction: column;
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
  
  .footerLeft {
    @include breakpoints.desktop {
      margin-left: 20%;
    }
  }
  
  .footerRight {
    @include breakpoints.desktop {
      margin-right: 20%;
      font-weight: 600;
      font-style: Semibold;
      font-size: 16px;
      line-height: 100%;
      text-align: center;
      vertical-align: middle;
      text-transform: uppercase;
      color: var(--Brand-Indigo, var(--brand-indigo));
    }
  }
  
  .footerDivider {
    margin: 28px 0;
    height: 1px;
    border: 0;
    margin-left: 95px;
    margin-right: 95px;
    background-color: #0033664D;

  
    @include breakpoints.desktop {
      flex-shrink: 0;
      height: auto;
      width: 1px;
      margin: 0 64px;
    }
  }
  
  .footerHeading {
    font-weight: 600;
    font-family: typography.$font-mont;
    font-style: normal;
    font-size: 16px;
    color: var(--brand-indigo);
    line-height: 100%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;

    text-align: center;
    margin: 0;
    letter-spacing: 0caps;
  
    @include breakpoints.desktop {
      padding-bottom: 8px;
    }
  }
  
  .footerHeadingWithTooltip {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    .footerHeading {
      padding-bottom: 0;
    }
  
    > :first-child {
      margin-right: 0;
      font-family: typography.$font-mont;
      font-weight: 600;
      font-style: normal;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0px;
      text-align: center;
      vertical-align: middle;
      text-transform: uppercase;
      color: var(--brand-indigo)
    }
  }
  
  .footerParagraph {
    text-align: center;
    margin: 8px 0 0;
    font-family: typography.$font-mont;
    width: 90%;
    margin-left: 20px;
  
    @include breakpoints.desktop {
      margin-top: auto;
      padding: 0px;
      font-weight: 400;
      font-style: Regular;
      font-size: 16px;
      line-height: 22.4px;
      letter-spacing: 0.32px;
      text-align: center;
      vertical-align: middle;
      color: var(--brand-indigo)
    }
  }
  
  .footerPhoneLink {
    display: inline-block;
    white-space: nowrap;
    text-decoration-skip-ink: none;
  }
  
  .footerLinkContainer {
    text-align: center;
    margin: 32px 0;
  
    @include breakpoints.desktop {
      margin: 16px 0;
    }
  }

  .footerRight .footerLinkContainer:last-child {
    @include breakpoints.desktop {
      margin-top: auto;
      margin-bottom: 0;
    }
  }
  
  .footerLink {
    color: var(--black);
    text-transform: uppercase;
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: Regular;
    font-size: 16px;
    line-height: 22.4px;
    letter-spacing: 0.32px;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;
    text-decoration: underline;
    text-underline-offset: 2px;
    text-decoration-skip-ink: auto;
    color: var(--Brand-Indigo, var(--brand-indigo));
  }
  
  .footerNextBtn {
    margin: 0px 0px 30px 0px;
  }

  .smsFooter {
    padding: 0px 20% 20px 20%;
    background: var(--white);
    text-align: center;
    margin-top: -16px;
    font-family: typography.$font-mont;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    padding-top: 30px;
    color: var(--Brand-Indigo, var(--brand-indigo));
  }

  .smsFooter a {
    color: inherit;
    text-decoration: none;
  }

  .agreeText {
    margin: 0;
  }

  .agreeText p {
    margin: 0;
  }

  .agreeText u {
    text-decoration: none;
  }
